export const NAME = 'balance';

export const REQUEST_USER_BALANCE = 'REQUEST_USER_BALANCE';
export const RECEIVE_USER_BALANCE = 'RECEIVE_USER_BALANCE';
export const FAILURE_USER_BALANCE = 'FAILURE_USER_BALANCE';



// WEBPACK FOOTER //
// ./src/services/account/balance/constants.js